




















import { Component, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import EditorMain from '@/components/question-editor/new-editor/EditorMain.vue';
import { getQuestionById } from '@/utils/add-question/add-question-util';
import { Question } from '@/resource/question/question.model';
import { MetaInfo } from 'vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  components: { MainButton, EditorMain },
  metaInfo(this: QuestionEditor): MetaInfo {
    return {
      title: 'Editor Soalan |',
      meta: [
        ...seoDefault({
          title: 'Editor Soalan | Mysoalan',
          description: 'Editor Soalan',
        }),
      ],
    };
  },
})
export default class QuestionEditor extends Vue {
  question: Question | null = null;
  isLoading = true;
  showEditor = false;
  showScreenSizeError = false;

  get isSubjective() {
    return this.$route.query['is-subjective'] === 'true';
  }

  get isAdmin() {
    return this.$route.query['is-admin'] === 'true';
  }

  get questionId() {
    return (
      (this.$route.query['question-id'] &&
        parseInt(this.$route.query['question-id'] as string)) ||
      null
    );
  }

  get paperUuid() {
    if (this.isAdmin) return null;
    return (this.$route.query['paper-uuid'] as string) || null;
  }

  get paperItemId() {
    if (this.isAdmin) return null;

    return (
      (this.$route.query['paper-item-id'] &&
        parseInt(this.$route.query['paper-item-id'] as string)) ||
      null
    );
  }

  async created() {
    if (window.innerWidth < 860) {
      this.showScreenSizeError = true;
    } else {
      await this.fetchQuestion();
      this.isLoading = false;
      this.showEditor = true;
    }

    window.addEventListener('resize', this.onScreenSizeChange);
  }

  destroyed() {
    window.removeEventListener('resize', this.onScreenSizeChange);
  }

  onScreenSizeChange() {
    if (window.innerWidth < 860) {
      this.showScreenSizeError = true;
      this.showEditor = false;
    } else {
      this.showScreenSizeError = false;
      this.showEditor = true;
    }
  }

  closeQuestionEditor() {
    if (this.isAdmin) {
      this.$router.push({
        path: 'dashboard',
      });
    } else {
      this.$router.push({
        name: 'paper',
        params: { uuid: this.paperUuid || '' },
      });
    }
  }

  async fetchQuestion() {
    if (this.questionId) {
      this.question = await getQuestionById(this.questionId, this.isSubjective);
    }
  }
}
